import { Decodable } from './_decodable';
import { PagePost } from './page-post';

class PageSettings extends Decodable {
  slogan!: string;
  institutional!: string;
  ogTitle!: string;
  ogImage!: string;
  bannerImage!: string;
  embedableDomains!: string;
  images!: any[];
  posts!: PagePost[];
  latitude!: number;
  longitude!: number;
  showProductsOnCota!: boolean;
  showMapBlock!: boolean;
  cotaInstructions!: string | null;

  _map = {
    posts: (data: any) => PagePost.parse(data) as PagePost[],
  };
}

export { PageSettings };
